import { Box, Text } from "@chakra-ui/react";
import React from "react";

export const ErrorFallBack = (
  <Box px={4} py={2}>
    <Text>Something went wrong, please try again.</Text>
  </Box>
);
